<!-- FILTERS -->
<div class="audit-filters-container">

  <!-- filters + calendar + actions (all in one grid) -->
  <div class="audit-filters-row">

    <!-- Calendar (same as AuditLogsComponent) -->
    <div class="audit-filter-item audit-filter-calendar">
      <div class="label">
        {{ 'users:audit_calendar' | i18next : { defaultValue: 'Calendar' } }}
      </div>

      <app-basic-date-range-picker
        [showTitle]="false"
        [initialPreset]="'yesterday'"
        [minDate]="minAuditDate"
        (rangeChange)="onCalendarRangeChange($event)">
      </app-basic-date-range-picker>
    </div>

    <!-- User name -->
    <div class="audit-filter-item">
      <app-basic-textbox
        [(model)]="loginFilters.userName"
        label="{{ 'frontPage:userName' | i18next : { defaultValue: 'User name' } }}"
        type="text"
        width="200px"
        size="medium"
        class="switch-time-textbox">
      </app-basic-textbox>
    </div>

    <!-- Client type -->
    <div class="audit-filter-item">
      <app-basic-dropdown
        class="form-select"
        label="{{ 'frontPage:clientType' | i18next : { defaultValue: 'Client type' } }}"
        width="200px"
        size="medium"
        [(model)]="loginFilters.clientType"
        [items]="clientTypes"
        bindLabel="label"
        bindValue="value"
        placeholder="{ 'frontPage:selectClientType' | i18next : { defaultValue: 'Select client type' } }"
        [clearable]="false"
        [searchable]="false">
      </app-basic-dropdown>
    </div>

    <!-- Login mode -->
    <div class="audit-filter-item">
      <app-basic-dropdown
        class="form-select"
        label="{{ 'users:audit_login_mode' | i18next : { defaultValue: 'Login mode' } }}"
        size="medium"
        [(model)]="loginFilters.loginMode"
        [items]="loginModes"
        bindLabel="description"
        bindValue="value"
        width="200px"
        [clearable]="false"
        [searchable]="false">
      </app-basic-dropdown>
    </div>

    <!-- IP address -->
    <div class="audit-filter-item">
      <app-basic-textbox
        label="{{ 'frontPage:ipAddress' | i18next : { defaultValue: 'IP address' } }}"
        [(model)]="loginFilters.ip"
        type="text"
        width="200px"
        size="medium"
        class="switch-time-textbox">
      </app-basic-textbox>
    </div>

    <!-- Actions: (optional message) + buttons, in the grid -->
    <div class="audit-filters-actions">
      <div class="audit-filters-message">
        {{ maxResultsInfoMessage }}
      </div>

      <div class="audit-filters-buttons">
        <app-basic-button
          type="secondary"
          size="medium"
          (click)="onReset()">
          {{ 'users:reset' | i18next : { defaultValue: 'Reset' } }}
        </app-basic-button>

        <app-basic-button
          type="primary"
          size="medium"
          (click)="onSearchLogin()">
          {{ 'services:supervisor_search' | i18next : { defaultValue: 'Search' } }}
        </app-basic-button>
      </div>
    </div>
  </div>
</div>

<!-- error -->
<div *ngIf="errorMessage" class="table-error">
  {{ errorMessage }}
</div>

<!-- loading bar like realtime queues -->
<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<!-- no data template -->
<ng-template #noData>
  <div class="no-items">
    {{ 'users:noresult' | i18next : { defaultValue: 'No results.' } }}
  </div>
</ng-template>

<!-- LOGIN TABLE (Material) -->
<table
  mat-table
  [dataSource]="dataSource"
  matSort
  class="mat-elevation-z2 full-width-table"
  id="LoginTable">

  <!-- Date & Time -->
  <ng-container matColumnDef="timeLoggedin">
    <th mat-header-cell *matHeaderCellDef mat-sort-header class="left">
      {{ 'users:audit_dateAndTime' | i18next : { defaultValue: 'Date and time' } }}
    </th>
    <td mat-cell *matCellDef="let item" class="left">
      {{ item.timeLoggedinString }}
    </td>
  </ng-container>

  <!-- User Name -->
  <ng-container matColumnDef="displayName">
    <th mat-header-cell *matHeaderCellDef class="left" mat-sort-header>
      {{ 'frontPage:userName' | i18next : { defaultValue: 'User name' } }}
    </th>
    <td mat-cell *matCellDef="let item" class="left">
      {{ item.displayName }}
    </td>
  </ng-container>

  <!-- Client Type -->
  <ng-container matColumnDef="clientType">
    <th mat-header-cell *matHeaderCellDef class="left" mat-sort-header>
      {{ 'frontPage:clientType' | i18next : { defaultValue: 'Client type' } }}
    </th>
    <td mat-cell *matCellDef="let item" class="left">
      {{ item.clientType }}
    </td>
  </ng-container>

  <!-- Operating System -->
  <ng-container matColumnDef="operationSystem">
    <th mat-header-cell *matHeaderCellDef class="left" mat-sort-header>
      {{ 'frontPage:operationSystem' | i18next : { defaultValue: 'Operating system' } }}
    </th>
    <td mat-cell *matCellDef="let item" class="left">
      <ng-container *ngIf="!item.clientInfoFormatted">
        {{ item.operationSystem }}
      </ng-container>
      <ng-container *ngIf="item.clientInfoFormatted">
        <a href="#"
           class="status"
           [attr.title]="item.clientInfoFormatted"
           (click)="$event.preventDefault(); openUserAgentInfo(item.clientInfoFormatted)">
          {{ item.operationSystem }}
        </a>
      </ng-container>
    </td>
  </ng-container>

  <!-- Web Browser -->
  <ng-container matColumnDef="webBrowser">
    <th mat-header-cell *matHeaderCellDef class="left" mat-sort-header>
      {{ 'frontPage:webBrowser' | i18next : { defaultValue: 'Web browser' } }}
    </th>
    <td mat-cell *matCellDef="let item" class="left">
      <ng-container *ngIf="!item.clientInfoFormatted">
        {{ item.webBrowser }}
      </ng-container>
      <ng-container *ngIf="item.clientInfoFormatted">
        <a href="#"
           class="status"
           [attr.title]="item.clientInfoFormatted"
           (click)="$event.preventDefault(); openUserAgentInfo(item.clientInfoFormatted)">
          {{ item.webBrowser }}
        </a>
      </ng-container>
    </td>
  </ng-container>

  <!-- IP Address -->
  <ng-container matColumnDef="ip">
    <th mat-header-cell *matHeaderCellDef class="left" mat-sort-header>
      {{ 'frontPage:ipAddress' | i18next : { defaultValue: 'IP address' } }}
    </th>
    <td mat-cell *matCellDef="let item" class="left">
      {{ item.ip }}
    </td>
  </ng-container>

  <!-- Login Status -->
  <ng-container matColumnDef="logInStatus">
    <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
      {{ 'users:loginStatus' | i18next : { defaultValue: 'Login status' } }}
    </th>
    <td mat-cell *matCellDef="let item" class="right">
      {{ 'audit:' + item.logInStatus | i18next }}
    </td>
  </ng-container>

  <!-- header / rows -->
  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

  <!-- no data row -->
  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" [attr.colspan]="displayedColumns.length">
      <ng-container *ngTemplateOutlet="noData"></ng-container>
    </td>
  </tr>
</table>
